import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ProcessCompleteDialogData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-process-complete-dialog',
  templateUrl: './process-complete-dialog.component.html',
  styleUrls: ['./process-complete-dialog.component.scss'],
})
export class ProcessCompleteDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public readonly data: ProcessCompleteDialogData,
    private readonly dialogRef: MatDialogRef<ProcessCompleteDialogComponent>,
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
